import { bl_pos_card_terminal_settlement_method_RowClass } from '../../../dbschema/bl_pos_card_terminal_settlement_method.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosCardTerminalSettlementMethodContainerModel extends BaseContainerModel {
  bl_pos_card_terminal_settlement_method: bl_pos_card_terminal_settlement_method_RowClass = new bl_pos_card_terminal_settlement_method_RowClass();
}
